export const environment = {
  production: true,
  host: 'https://api.z-link.site',
  apiUrl: 'https://api.z-link.site',
  googleClientId: '',
  facebookClientId: '',
};
